// Client-configurable joining fee, parsed from the fees.joining client_setting.
// Defaults reproduce the previous hardcoded behaviour (£25, the "Initial Member
// Joining Fee" POS item) so an unconfigured client is unchanged.

export interface JoiningFeeConfig {
    enabled: boolean;
    amount: number;
    label: string;
    // Name of the POS item used as the line item for the initial payment.
    posItemName: string;
}

export const DEFAULT_JOINING_FEE: JoiningFeeConfig = {
    enabled: true,
    amount: 25,
    label: 'Initial Member Joining Fee',
    posItemName: 'Initial Member Joining Fee',
};

export function parseJoiningFee(json: string | undefined | null): JoiningFeeConfig {
    if (!json) return DEFAULT_JOINING_FEE;
    try {
        const parsed = JSON.parse(json);
        if (!parsed || typeof parsed !== 'object') return DEFAULT_JOINING_FEE;
        return {
            enabled: typeof parsed.enabled === 'boolean' ? parsed.enabled : DEFAULT_JOINING_FEE.enabled,
            // Use == null so a legitimate 0 fee is respected (a free joining fee).
            amount: typeof parsed.amount === 'number' ? parsed.amount : DEFAULT_JOINING_FEE.amount,
            label: typeof parsed.label === 'string' && parsed.label.trim()
                ? parsed.label
                : DEFAULT_JOINING_FEE.label,
            posItemName: typeof parsed.posItemName === 'string' && parsed.posItemName.trim()
                ? parsed.posItemName
                : DEFAULT_JOINING_FEE.posItemName,
        };
    } catch {
        return DEFAULT_JOINING_FEE;
    }
}
